import { observer } from 'mobx-react-lite'
import { useMemo, useState } from 'react'
import { type ITabItem, Tabs } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { TabEnroll } from '../TabEnroll'
import { TabConversation } from '../TabConversation'
import { TabObjective } from '../TabObjective'
import { TabQualify } from '../TabQualify'
import { TabActions } from '../TabActions'
import { useDetailsContext } from '../detailsContext'
import styles from './styles.module.scss'

enum DetailsTabEnum {
  Enroll = 'enroll',
  Conversation = 'conversation',
  Objective = 'objective',
  Qualify = 'qualify',
  Actions = 'actions',
}

const TABS: ITabItem<DetailsTabEnum>[] = [
  {
    key: DetailsTabEnum.Enroll,
    name: 'Enroll your contacts',
  },
  {
    key: DetailsTabEnum.Conversation,
    name: 'Style your conversation',
  },
  {
    key: DetailsTabEnum.Objective,
    name: 'Collect data',
  },
  {
    key: DetailsTabEnum.Qualify,
    name: 'Qualify',
  },
  {
    key: DetailsTabEnum.Actions,
    name: 'Actions',
  },
]

const getTabContent = (tab: DetailsTabEnum) => {
  switch (tab) {
    case DetailsTabEnum.Enroll:
      return TabEnroll
    case DetailsTabEnum.Conversation:
      return TabConversation
    case DetailsTabEnum.Objective:
      return TabObjective
    case DetailsTabEnum.Qualify:
      return TabQualify
    case DetailsTabEnum.Actions:
      return TabActions
    default:
      return () => null
  }
}

export const DetailsTabs = observer(() => {
  const { featureFlagsStore } = useEntitiesContext()
  const detailsStore = useDetailsContext()
  const [activeTab, setActiveTab] = useState(DetailsTabEnum.Enroll)
  const TabContent = useMemo(() => getTabContent(activeTab), [activeTab])

  const activateTab = (tab: ITabItem<DetailsTabEnum>) => setActiveTab(tab.key)
  const filteredTabs =
    featureFlagsStore.qualify && detailsStore.qualifyEnabled
      ? TABS
      : TABS.filter((item) => item.key !== DetailsTabEnum.Qualify)

  return (
    <div className={styles.detailsTabs}>
      <Tabs
        tabs={filteredTabs}
        activeTabKey={activeTab}
        handleSelectTab={activateTab}
        tabsClassName={styles.tabs}
      />
      <div className={styles.tabContentWrapper}>
        <TabContent />
      </div>
    </div>
  )
})
